import { LANGUAGE_DATA } from './types';

export const LANG_DATA: LANGUAGE_DATA = {
  Hindi: {
    lang_name: 'हिंदी',
    captionItem: {
      updatedOn: 'Updated on',
      switchTo: 'Switch Language',
      minRead: 'min read',
    },
    breadcrumb: {
      home: 'HOME',
    },
    sideBar: {
      hide: 'छिपाना',
      show: 'प्रदर्शन',
      content: 'विषयसूची',
      quickSummary: 'त्वरित सारांश',
      feedbackText: 'क्या यह सारांश उपयोगी था?',
      article: 'All Articles',
      popularArticle: 'POPULAR ARTICLES',
      interestedArticle: 'You might be interested in',
      recentArticle: 'Recent Articles',
    },
  },
  English: {
    lang_name: 'English',
    captionItem: {
      updatedOn: 'Updated on',
      switchTo: 'Switch Language',
      minRead: 'min read',
    },
    breadcrumb: {
      home: 'Home',
    },
    sideBar: {
      hide: 'Hide',
      show: 'Show',
      content: 'Index',
      quickSummary: 'Quick Summary',
      feedbackText: 'Was this summary helpful?',
      article: 'All Articles',
      popularArticle: 'POPULAR ARTICLES',
      interestedArticle: 'You might be interested in',
      recentArticle: 'Recent Articles',
    },
  },
  Dutch: {
    lang_name: 'Dutch',
    captionItem: {
      updatedOn: 'Bijgewerkt op',
      switchTo: 'Taal wijzigen',
      minRead: 'min lezen',
    },
    breadcrumb: {
      home: 'Home',
    },
    sideBar: {
      hide: 'Verbergen',
      show: 'Tonen',
      content: 'Inhoudsopgave',
      quickSummary: 'Korte samenvatting',
      feedbackText: 'Was deze samenvatting nuttig?',
      article: 'Alle artikelen',
      popularArticle: 'POPULAIRE ARTIKELEN',
      interestedArticle: 'Dit vind je misschien interessant',
      recentArticle: 'Recente artikelen',
    },
  },
  Arabic: {
    lang_name: ' اللغة العربية',
    breadcrumb: {
      home: '\u0627\u0644\u0635\u0641\u062d\u0629 \u0627\u0644\u0631\u0626\u064a\u0633\u064a\u0629',
    },
    captionItem: {
      updatedOn:
        '\u062a\u0645 \u0627\u0644\u062a\u062d\u062f\u064a\u062b \u0641\u064a',
      switchTo: '\u0627\u0644\u062a\u0628\u062f\u064a\u0644 \u0625\u0644\u0649',
      minRead:
        '\u0642\u064a\u0642\u0629 \u0644\u0644\u0642\u0631\u0627\u0621\u0629',
    },
    sideBar: {
      hide: '\u0621\u0627\u0641\u062e\u0625',
      show: '\u0645\u0634\u0627\u0647\u062f\u0647',
      content: '\u0627\u0644\u0645\u062d\u062a\u0648\u064a\u0627\u062a',
      article: '\u0627\u0644\u0645\u0642\u0627\u0644\u0629',
      quickSummary: 'ملخص سريع',
      feedbackText: 'هل كان هذا الملخص مفيدًا؟',
      popularArticle:
        '\u0627\u0644\u0623\u0643\u062b\u0631 \u0634\u064a\u0648\u0639\u0627\u064b',
      interestedArticle:
        '\u0642\u062f \u062a\u0643\u0648\u0646 \u0645\u0647\u062a\u0645 \u0641\u064a',
      recentArticle:
        '\u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062a \u0627\u0644\u062c\u062f\u064a\u062f\u0629',
    },
  },
  Marathi: {
    lang_name: 'मराठी',
    captionItem: {
      updatedOn: 'Updated on',
      switchTo: 'Switch Language',
      minRead: 'min read',
    },
    breadcrumb: {
      home: 'HOME',
    },
    sideBar: {
      hide: 'लपवा',
      show: 'दाखवा',
      content: 'सामग्री सारणी',
      article: 'All Articles',
      quickSummary: 'द्रुत सारांश',
      feedbackText: 'हा सारांश उपयुक्त होता का?',
      popularArticle: 'POPULAR ARTICLES',
      interestedArticle: 'You might be interested in',
      recentArticle: 'Recent Articles',
    },
  },
  Tamil: {
    lang_name: 'தமிழ்',
    captionItem: {
      updatedOn: 'Updated on',
      switchTo: 'Switch Language',
      minRead: 'min read',
    },
    breadcrumb: {
      home: 'HOME',
    },
    sideBar: {
      hide: 'மறைக்க',
      show: 'நிகழ்ச்சி',
      content: 'பொருளடக்கம்',
      article: 'All Articles',
      quickSummary: 'விரைவான சுருக்கம்',
      feedbackText: 'இந்த சுருக்கம் உதவியாக இருந்ததா?',
      popularArticle: 'POPULAR ARTICLES',
      interestedArticle: 'You might be interested in',
      recentArticle: 'Recent Articles',
    },
  },
  Telugu: {
    lang_name: 'తెలుగు',
    captionItem: {
      updatedOn: 'Updated on',
      switchTo: 'Switch Language',
      minRead: 'min read',
    },
    breadcrumb: {
      home: 'HOME',
    },
    sideBar: {
      hide: 'దాచు',
      show: 'చూపించు',
      content: 'విషయ సూచిక',
      article: 'All Articles',
      quickSummary: 'శీఘ్ర సారాంశం',
      feedbackText: 'ఈ సారాంశం సహాయకరంగా ఉందా?',
      popularArticle: 'POPULAR ARTICLES',
      interestedArticle: 'You might be interested in',
      recentArticle: 'Recent Articles',
    },
  },
  Kannada: {
    lang_name: 'ಕನ್ನಡ',
    captionItem: {
      updatedOn: 'Updated on',
      switchTo: 'Switch Language',
      minRead: 'min read',
    },
    breadcrumb: {
      home: 'HOME',
    },
    sideBar: {
      hide: 'ಮರೆಮಾಡಿ',
      show: 'ತೋರಿಸು',
      content: 'ಪರಿವಿಡಿ',
      article: 'All Articles',
      quickSummary: 'ತ್ವರಿತ ಸಾರಾಂಶ',
      feedbackText: 'ಈ ಸಾರಾಂಶವು ಸಹಾಯಕವಾಗಿದೆಯೇ?',
      popularArticle: 'POPULAR ARTICLES',
      interestedArticle: 'You might be interested in',
      recentArticle: 'Recent Articles',
    },
  },
  French: {
    lang_name: 'French',
    captionItem: {
      updatedOn: 'Mis à jour le',
      switchTo: 'Changer de langue',
      minRead: 'lecture minimale',
    },
    breadcrumb: {
      home: 'MAISON',
    },
    sideBar: {
      hide: 'Cacher',
      show: 'Montrer',
      content: 'CONTENU',
      article: 'Tous les articles',
      quickSummary: 'Résumé rapide',
      feedbackText: 'Ce résumé a-t-il été utile ?',
      popularArticle: 'ARTICLES POPULAIRES',
      interestedArticle: 'Vous pourriez être intéressé par',
      recentArticle: 'Articles récents',
    },
  },
  Spanish: {
    lang_name: 'Spanish',
    captionItem: {
      updatedOn: 'Actualizado en',
      switchTo: 'Cambiar idioma',
      minRead: 'lectura mínima',
    },
    breadcrumb: {
      home: 'HOGAR',
    },
    sideBar: {
      hide: 'Esconder',
      show: 'Espectáculo',
      content: 'CONTENIDO',
      article: 'Todos los artículos',
      quickSummary: 'Sumario rápido',
      feedbackText: '¿Le resultó útil este resumen?',
      popularArticle: 'ARTICULOS POPULARES',
      interestedArticle: 'Te podría interesar',
      recentArticle: 'Artículos Recientes',
    },
  },
  Polish: {
    lang_name: 'Polish',
    captionItem: {
      updatedOn: 'Zaktualizowano w dniu',
      switchTo: 'Zmień język',
      minRead: 'min przeczytaj',
    },
    breadcrumb: {
      home: 'DOM',
    },
    sideBar: {
      hide: 'Ukrywać',
      show: 'Pokazywać',
      content: 'ZAWARTOŚĆ',
      article: 'Wszystkie artykuły',
      quickSummary: 'Szybkie podsumowanie',
      feedbackText: 'Czy to podsumowanie było pomocne?',
      popularArticle: 'POPULARNE ARTYKUŁY',
      interestedArticle: 'Możesz być zainteresowany',
      recentArticle: 'Ostatnie Artykuły',
    },
  },
  Malay: {
    lang_name: 'Malay',
    captionItem: {
      updatedOn: 'Dikemas kini pada',
      switchTo: 'Tukar Bahasa',
      minRead: 'min baca',
    },
    breadcrumb: {
      home: 'RUMAH',
    },
    sideBar: {
      hide: 'Sembunyi',
      show: 'Tunjukkan',
      content: 'KANDUNGAN',
      article: 'Semua Artikel',
      quickSummary: 'Ringkasan Pantas',
      feedbackText: 'Adakah ringkasan ini membantu?',
      popularArticle: 'ARTIKEL POPULAR',
      interestedArticle: 'Anda mungkin berminat',
      recentArticle: 'Artikel Terkini',
    },
  },
  Korean: {
    lang_name: 'Korean',
    captionItem: {
      updatedOn: '업데이트 날짜',
      switchTo: '언어 변경',
      minRead: '최소 읽기',
    },
    breadcrumb: {
      home: '홈',
    },
    sideBar: {
      hide: '숨기기',
      show: '보이기',
      content: '목차',
      article: '모든 기사',
      quickSummary: '빠른 요약',
      feedbackText: '이 요약이 도움이 되었나요?',
      popularArticle: '인기 기사',
      interestedArticle: '관심 있을 만한 기사',
      recentArticle: '최근 기사',
    },
  },
  Japanese: {
    lang_name: 'Japanese',
    captionItem: {
      updatedOn: '更新日',
      switchTo: '言語を切り替える',
      minRead: '最小読書時間',
    },
    breadcrumb: {
      home: 'ホーム',
    },
    sideBar: {
      hide: '非表示',
      show: '表示',
      content: '目次',
      article: 'すべての記事',
      quickSummary: 'クイックサマリー',
      feedbackText: 'この要約は役に立ちましたか？',
      popularArticle: '人気の記事',
      interestedArticle: '興味があるかもしれない記事',
      recentArticle: '最近の記事',
    },
  },
  Albanian: {
    lang_name: 'Albanian',
    captionItem: {
      updatedOn: 'Përditësuar më',
      switchTo: 'Ndrysho gjuhën',
      minRead: 'lexim minimal',
    },
    breadcrumb: {
      home: 'Shtëpi',
    },
    sideBar: {
      hide: 'Fshih',
      show: 'Shfaq',
      content: 'Përmbajtja',
      article: 'Të gjitha artikujt',
      quickSummary: 'Përmbledhje e shpejtë',
      feedbackText: 'A ishte kjo përmbledhje e dobishme?',
      popularArticle: 'ARTIKUJ POPULLORË',
      interestedArticle: 'Mund të jeni të interesuar në',
      recentArticle: 'Artikujt e fundit',
    },
  },
  Filipino: {
    lang_name: 'Filipino',
    captionItem: {
      updatedOn: 'Na-update noong',
      switchTo: 'Palitan ang Wika',
      minRead: 'min basahin',
    },
    breadcrumb: {
      home: 'Tahanan',
    },
    sideBar: {
      hide: 'Itago',
      show: 'Ipakita',
      content: 'Nilalaman',
      article: 'Lahat ng Artikulo',
      quickSummary: 'Mabilis na Buod',
      feedbackText: 'Nakakatulong ba ang buod na ito?',
      popularArticle: 'MGA POPULAR NA ARTIKULO',
      interestedArticle: 'Maaaring interesado ka sa',
      recentArticle: 'Mga Kamakailang Artikulo',
    },
  },
};
